var React = require('react');

function Dashboard (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 0.25C1.92893 0.25 0.25 1.92893 0.25 4V20C0.25 22.0711 1.92893 23.75 4 23.75H20C22.0711 23.75 23.75 22.0711 23.75 20V4C23.75 1.92893 22.0711 0.25 20 0.25H4ZM22.25 6.25V4C22.25 2.75736 21.2426 1.75 20 1.75H4C2.75736 1.75 1.75 2.75736 1.75 4V6.25H22.25ZM1.75 7.75V20C1.75 21.2426 2.75736 22.25 4 22.25H7.25V7.75H1.75ZM8.75 22.25V7.75H22.25V20C22.25 21.2426 21.2426 22.25 20 22.25H8.75Z","fill":"white"}));
}

Dashboard.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Dashboard;

Dashboard.default = Dashboard;
